import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import * as typography from '@tapas/typography';
var TooltipButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1.6rem;\n  height: 1.6rem;\n  padding: 0;\n  box-sizing: border-box;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n\n  path {\n    fill: ", ";\n  }\n"], ["\n  width: 1.6rem;\n  height: 1.6rem;\n  padding: 0;\n  box-sizing: border-box;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n\n  path {\n    fill: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.hierarchy.h3;
});
var TooltipArrow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: inherit;\n  width: 1rem;\n  height: 1rem;\n  visibility: hidden;\n\n  ", ";\n\n  ::before {\n    background: inherit;\n    position: absolute;\n    visibility: visible;\n    content: '';\n    transform: rotate(45deg);\n    width: 100%;\n    height: 100%;\n    border-radius: 0.25rem;\n  }\n"], ["\n  background: inherit;\n  width: 1rem;\n  height: 1rem;\n  visibility: hidden;\n\n  ", ";\n\n  ::before {\n    background: inherit;\n    position: absolute;\n    visibility: visible;\n    content: '';\n    transform: rotate(45deg);\n    width: 100%;\n    height: 100%;\n    border-radius: 0.25rem;\n  }\n"])), function (_a) {
  var placement = _a.placement;

  if (placement.startsWith('top')) {
    return "\n        bottom: -0.35rem;\n      ";
  }

  if (placement.startsWith('bottom')) {
    return "\n        top: -0.35rem;\n      ";
  }

  if (placement.startsWith('left')) {
    return "\n        right: -0.35rem;\n      ";
  }

  return "\n      left: -0.35rem;\n  ";
});
var TooltipPopper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  opacity: ", ";\n  max-width: 32.8rem;\n  padding: 0.8rem 1.2rem;\n  border-radius: 0.8rem;\n  box-sizing: border-box;\n  color: ", ";\n  background: ", ";\n  transition: opacity 0.1s linear;\n\n  ", "\n  @media screen and (min-width: 481px) {\n    ", "\n  }\n"], ["\n  display: flex;\n  opacity: ", ";\n  max-width: 32.8rem;\n  padding: 0.8rem 1.2rem;\n  border-radius: 0.8rem;\n  box-sizing: border-box;\n  color: ", ";\n  background: ", ";\n  transition: opacity 0.1s linear;\n\n  ", "\n  @media screen and (min-width: 481px) {\n    ", "\n  }\n"])), function (_a) {
  var show = _a.show;
  return show ? 1 : 0;
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.accent.on;
}, function (_a) {
  var theme = _a.theme,
      styleType = _a.styleType;
  return styleType === 'black' ? theme.colorTokens.hierarchy.h1 : theme.colorTokens.accent.default;
}, function (_a) {
  var theme = _a.theme;
  return typography.caption(theme.fonts.default, 500);
}, function (_a) {
  var theme = _a.theme;
  return typography.body(theme.fonts.default, 1.4, 500);
});
var templateObject_1, templateObject_2, templateObject_3;
export { TooltipArrow, TooltipButton, TooltipPopper };